import { useMemo, useRef, useState } from 'react'
import clsx from 'clsx'
import AddIcon from '@mui/icons-material/Add'
import { useDispatch } from 'react-redux'

import { useElementScroll } from 'components/ElementScroll'
import Button from 'components/Button'
import { FormDialog, dialogActions } from 'duck/AppDuck/DialogDuck'
import { useBreakpoint } from 'utils/Hooks'
import Portal from 'components/Portal'
import { twMerge } from 'tailwind-merge'

import styles from './FloatingActions.module.scss'

type FloatingActionsProps = {}

function FloatingActions(props: FloatingActionsProps) {
  const dispatch = useDispatch()
  const refContainer = useRef<HTMLDivElement | null>(null)
  const refContainerCurrent = refContainer.current
  const [showFloatingFilter, setShowFloatingFilter] = useState(false)
  const { isMediumscreenAbove } = useBreakpoint()

  const scrollConfig = useMemo(() => {
    return {
      name: 'Page',
      onScroll: (scrollTop: number) => {
        if (
          refContainerCurrent &&
          scrollTop >= refContainerCurrent.offsetTop + refContainerCurrent.clientHeight
        )
          setShowFloatingFilter(true)
        else setShowFloatingFilter(false)
      }
    }
  }, [refContainerCurrent])

  useElementScroll(scrollConfig)

  return (
    <div ref={refContainer}>
      <Portal container="body">
        <div
          className={twMerge(
            'fixed bottom-4 right-3 z-1 flex flex-col items-end sm:bottom-9 sm:right-9',
            styles.FloatingFilterContainer,
            showFloatingFilter && styles.FloatingFilterContainerShow
          )}
        >
          {isMediumscreenAbove ? (
            <Button
              className="mb-2"
              onClick={() => {
                dispatch(
                  dialogActions.openDialog({
                    [FormDialog.NEW_PROJECT]: { dialogName: FormDialog.NEW_PROJECT }
                  })
                )
              }}
              variant="contained"
              color="secondary"
              startIcon={<AddIcon />}
            >
              CREATE PROJECT
            </Button>
          ) : null}
        </div>

        {!isMediumscreenAbove ? (
          <Button
            className={clsx(
              'fixed mb-2',
              styles.ButtonIconCreateProjectAlignRight,
              styles.FloatingFilterContainerShow
            )}
            onClick={() => {
              dispatch(
                dialogActions.openDialog({
                  [FormDialog.NEW_PROJECT]: { dialogName: FormDialog.NEW_PROJECT }
                })
              )
            }}
            variant="contained"
            color="secondary"
            startIcon={<AddIcon />}
          >
            CREATE
          </Button>
        ) : null}
      </Portal>
    </div>
  )
}

export default FloatingActions
